import http from "@/common/http-common";
import store from "@/store";

class UnitService {
  async loadAll() {
    return http().get("/api/v1/units.json").then(function(resp) {
      console.log("Inside UnitService.loadAll, resp.data ==> ", resp.data);
      const unitList = resp.data;
      const unitHash = unitList.reduce(function(h, unit) {
        const unitType = unit.type;
        if (h[unitType]) {
          h[unitType].push(unit);
        } else {
          h[unitType] = [unit];
        }
        return h;
      }, {})
      store.commit("updateUnits", unitHash);
    })

  }
}

export default new UnitService();